import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import * as actions from "./_redux/Actions";
import { useSubheader } from "../../../_metronic/layout";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import {
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar,
} from "../../../_metronic/_partials/controls";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../_metronic/_partials/controls";
import helperFunc from "../../../_metronic/_helpers/helperFunc";
import Upload from "../../components/upload/Upload";
import "../Game/AddGame/formcontrol.css";
import "../../../_metronic/_assets/sass/customstyle.react.scss";
const CommonForm = (props) => {
  const suhbeader = useSubheader();
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(undefined);
  const { id } = useParams();
  let history = useHistory();
  const [frmInitialValues, setFrmInitialValues] = useState({
    name: "",
    code: "",
    symbol: "",
    img: {},
    // prizePoolNote: '',
    // joiningNote: '',
    isActive: true,
    // isContestTournament: false,
  });

  const onChangeForm = (e) => {
    setFrmInitialValues({
      ...frmInitialValues,
      [e.target.name]: e.target.value,
    });
  };

  // Validation schem
  const CurrenciesEditSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    code: Yup.string().required("Code is required"),
    symbol: Yup.string().required("Symbol Code is required"),
  });

  const { currentState } = useSelector(
    (state) => ({ currentState: state.currency }),
    shallowEqual
  );
  const { actionsLoading, currencyForEdit, upload } = currentState;

  useEffect(() => {
    dispatch(actions.fetchSingle(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "New Currency";
    if (currencyForEdit && id) {
      console.log(currencyForEdit);
      _title = `Edit Currency '${currencyForEdit && currencyForEdit.name}'`;
      const item = currencyForEdit;
      const data = { ...frmInitialValues, ...item };
      setFile(item && item.img);
      setFrmInitialValues(data);
    } else {
      setFile(undefined);
    }
    setTitle(_title);
    suhbeader.setTitle(_title);
  }, [currencyForEdit, id]);

  const saveCurrency = () => {
    let data = {};
    data.name = frmInitialValues.name;
    data.code = frmInitialValues.code;
    data.symbol = frmInitialValues.symbol;
    data.isActive = frmInitialValues.isActive;

    let errors = []; // Collect errors

    // Check if any required field is empty
    if (!data.name) {
      errors.push("Please fill in the Name field");
    }

    if (!data.code) {
      errors.push("Please fill in the Code field");
    }

    if (!data.symbol) {
      errors.push("Please fill in the Symbol field");
    }

    if (!file) {
      errors.push("Please upload Image");
    }

    if (errors.length > 0) {
      // Display all errors at once
      errors.forEach((error) => NotificationManager.error(error, "Error"));
      return;
    }

    data.img = file;

    if (!id) {
      dispatch(actions.createItem(data)).then((success) => {
        if (success) {
          NotificationManager.success(
            "Currency created successfully",
            "Success",
            2000
          ); // Success toast with a 2-second delay
          setTimeout(backToList, 1000); // Navigate back to the list after 2 seconds
        }
      });
    } else {
      dispatch(actions.updateItem(data, id)).then((success) => {
        if (success) {
          NotificationManager.success(
            "Currency updated successfully",
            "Success",
            2000
          ); // Success toast with a 2-second delay
          setTimeout(backToList, 1000); // Navigate back to the list after 2 seconds
        }
      });
    }
  };

  const backToList = () => {
    history.push(`/currencies/list`);
    window.location.reload();
  };
  const onUpdateFileValue = (file) => {
    setFile(file.image);
  };
  const uploadImage = (e) => {
    if (e.target.files && e.target.files[0]) {
      let img = e.target.files[0];
      //   console.log('img: ', img);
      let payload = {
        img: img,
        name: "img",
      };
      dispatch(actions.uploadImage(payload));
    }
  };

  useEffect(() => {
    // console.log('first', countryList)
    setFile(upload);
  }, [upload]);

  return (
    <>
      <NotificationContainer />
      <Card>
        {actionsLoading && <ModalProgressBar />}
        <CardHeader title={title}></CardHeader>
        <CardBody>
          {/* <div className="report-filter-bLock border-0 row align-items-center">
                        <div className="row w-100 m-0">

                            <div className=" w-100 col-lg-6 mb-4">
                                <label>Name</label>
                                <input
                                    type="text"
                                    className=" w-200 form-control"
                                    placeholder="Name"
                                    name='name'
                                    value={frmInitialValues.name}
                                    onChange={onChangeForm}

                                    required
                                />
                            </div>
           <div className=" w-100 col-lg-6 mb-4">
                                <label>Code</label>
                                <input
                                    type="text"
                                    className=" w-200 form-control"
                                    placeholder="Code"
                                    name='code'
                                    value={frmInitialValues.code}
                                    onChange={onChangeForm}

                                    required
                                />
                            </div>

                            <div className="w-100 col-lg-6 mb-4">
                                <label>Website</label>
                                <input
                                    type="text"
                                    className=" w-200 form-control"
                                    placeholder="$"
                                    name="symbol"
                                    value={frmInitialValues.symbol}
                                    onChange={onChangeForm}

                                    required
                                />
                            </div>
                            <div className="col-lg-4 mb-4">
                                <label>Logo</label>
                                {file && file.default ? (
                                    <div className="form-group row">
                                        <div className="col-lg-4">
                                            <div className="thumb-image-display" style={{ overflow: 'visible', }}>
                                                <img alt="example" style={{ width: '100%' }} src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${file && file.default}`} />
                                                <div className="image-input-wrapper"></div>
                                                <label className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="change" title="Change Image" >
                                                    <i className="fa fa-pen icon-sm text-muted"></i>
                                                    <input type="file" name="image-upload" onChange={(e) => uploadImage(e)} accept=".png, .jpg, .jpeg" />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="form-group row">
                                        <div className="col-lg-4">
                                            <div className="image-input image-input-empty image-input-outline" id="kt_image_5"
                                                style={{ backgroundImage: `url(https://icons-for-free.com/iconfiles/png/512/box+document+outline+share+top+upload+icon-1320195323221671611.png)` }}
                                            >

                                                {file && file.default}
                                                <div className="image-input-wrapper"></div>
                                                <label className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="change" title="Change Image" >
                                                    <i className="fa fa-pen icon-sm text-muted"></i>
                                                    <input type="file" name="image-upload" onChange={(e) => uploadImage(e)} accept=".png, .jpg, .jpeg" />
                                                </label>
                                                <span className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="remove" title="Remove Image">
                                                    <i className="ki ki-bold-close icon-xs text-muted"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div> */}
          <Formik
            enableReinitialize={true}
            initialValues={frmInitialValues}
            validationSchema={CurrenciesEditSchema}
            onSubmit={(values) => {
              // return false
              saveCurrency(values);
            }}
          >
            {({ handleSubmit, values }) => (
              <Form className="form form-label-right">
                <div className="form-group row">
                  <div className="col-lg-3 col-md-6">
                    <Field
                      // className="form-controll"
                      name="name"
                      component={Input}
                      placeholder="Name"
                      label="Name"
                      isRequired={true}
                      value={frmInitialValues.name}
                      onChange={onChangeForm}
                    />
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <Field
                      // className="form-controll"
                      name="code"
                      component={Input}
                      placeholder="Code"
                      label="Code"
                      disabled={id ? true : false}
                      isRequired={true}
                      value={frmInitialValues.code}
                      onChange={onChangeForm}
                    />
                  </div>
                  <div className="col-lg-2 col-md-6">
                    <Field
                      // className="form-controll"
                      name="symbol"
                      component={Input}
                      placeholder="Symbol"
                      label="Symbol"
                      isRequired={true}
                      value={frmInitialValues.symbol}
                      onChange={onChangeForm}
                    />
                  </div>
                  {(helperFunc.isButtonAccess("master.currency.update") ||
                    helperFunc.isButtonAccess("master.currency.add")) && (
                    <div className="col-md-1">
                      <label className="col-form-label">Is Active</label>
                      <div className="col-12 w-100 p-0">
                        <span className="switch switch-primary switch-icon">
                          <label>
                            <Field
                              type="checkbox"
                              checked={frmInitialValues.isActive}
                              name="isActive"
                              onChange={(e) =>
                                setFrmInitialValues({
                                  ...frmInitialValues,
                                  isActive: e.target.checked,
                                })
                              }
                              // onChange={(e) => console.log(e.target.checked)}
                            />
                            <span></span>
                          </label>
                        </span>
                      </div>
                    </div>
                  )}
                  {/* <div className="col-md-3">
                                        <label className="col-form-label">Is Visible in Contest / Tournament</label>
                                        <div className="col-12 w-100 p-0">
                                            <span className="switch switch-primary switch-icon">
                                                <label>
                                                    <Field type="checkbox" name="isContestTournament" />
                                                    <span></span>
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <Field
                                            name="prizePoolNote"
                                            component={Input}
                                            placeholder={'T&C PrizePool Note'}
                                            label={'T&C PrizePool Note'}
                                        />
                                    </div>
                                    <div className="col-lg-12">
                                        <Field
                                            name="joiningNote"
                                            component={Input}
                                            placeholder={'T&C Joining Note'}
                                            label={'T&C Joining Note'}
                                        />
                                    </div> */}
                </div>
                <div className="form-group row">
                  <div className="col-lg-4">
                    <Field
                      name="img"
                      component={Upload}
                      label="Image"
                      file={file}
                      onfileValueSet={onUpdateFileValue}
                    />
                  </div>
                </div>
                <div className="form-group justify-content-end row mx-0">
                  <button
                    type="button"
                    onClick={backToList}
                    className="btn btn-light"
                  >
                    <i className="fa fa-arrow-left"></i>Back
                  </button>
                  {(
                    helperFunc.isButtonAccess("master.currency.add")) && (
                    <button
                      type="submit"
                      className="btn btn-primary ml-2"
                      // onCllick={saveCurrency}
                    >
                       {id ? "Update" : "Save"}
                    </button>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Card>
    </>
  );
};
export default CommonForm;
